/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ParentRouteImport } from './routes/parent'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FacultyRouteImport } from './routes/faculty'
import { Route as DancerRouteImport } from './routes/dancer'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ParentIndexRouteImport } from './routes/parent.index'
import { Route as FacultyIndexRouteImport } from './routes/faculty.index'
import { Route as DancerIndexRouteImport } from './routes/dancer.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as ParentScheduleRouteImport } from './routes/parent.schedule'
import { Route as ParentProgressRouteImport } from './routes/parent.progress'
import { Route as ParentProductionsRouteImport } from './routes/parent.productions'
import { Route as ParentPassesRouteImport } from './routes/parent.passes'
import { Route as ParentMessagesRouteImport } from './routes/parent.messages'
import { Route as ParentDancersRouteImport } from './routes/parent.dancers'
import { Route as ParentCompetitionsRouteImport } from './routes/parent.competitions'
import { Route as ParentBillingRouteImport } from './routes/parent.billing'
import { Route as FacultyProductionsRouteImport } from './routes/faculty.productions'
import { Route as FacultyClassesRouteImport } from './routes/faculty.classes'
import { Route as DancerVideosRouteImport } from './routes/dancer.videos'
import { Route as DancerCompetitionsRouteImport } from './routes/dancer.competitions'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminSecurityRouteImport } from './routes/admin.security'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminRecitalPackagesRouteImport } from './routes/admin.recital-packages'
import { Route as AdminProgramsRouteImport } from './routes/admin.programs'
import { Route as AdminProductionsRouteImport } from './routes/admin.productions'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminFamiliesRouteImport } from './routes/admin.families'
import { Route as AdminDancersRouteImport } from './routes/admin.dancers'
import { Route as AdminCostRouteImport } from './routes/admin.cost'
import { Route as AdminCompetitionsRouteImport } from './routes/admin.competitions'
import { Route as AdminClassesRouteImport } from './routes/admin.classes'
import { Route as AdminBroadcastsRouteImport } from './routes/admin.broadcasts'
import { Route as AdminBillingRouteImport } from './routes/admin.billing'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAssessmentsRouteImport } from './routes/admin.assessments'
import { Route as ParentMessagesIndexRouteImport } from './routes/parent.messages.index'
import { Route as AdminReportsIndexRouteImport } from './routes/admin.reports.index'
import { Route as AdminRecitalPackagesIndexRouteImport } from './routes/admin.recital-packages.index'
import { Route as AdminProgramsIndexRouteImport } from './routes/admin.programs.index'
import { Route as AdminProductionsIndexRouteImport } from './routes/admin.productions.index'
import { Route as AdminMessagesIndexRouteImport } from './routes/admin.messages.index'
import { Route as AdminLeadsIndexRouteImport } from './routes/admin.leads.index'
import { Route as AdminFamiliesIndexRouteImport } from './routes/admin.families.index'
import { Route as AdminCompetitionsIndexRouteImport } from './routes/admin.competitions.index'
import { Route as AdminClassesIndexRouteImport } from './routes/admin.classes.index'
import { Route as AdminBillingIndexRouteImport } from './routes/admin.billing.index'
import { Route as AdminAssessmentsIndexRouteImport } from './routes/admin.assessments.index'
import { Route as ParentSettingsNotificationsRouteImport } from './routes/parent.settings.notifications'
import { Route as ParentMessagesThreadIdRouteImport } from './routes/parent.messages.$threadId'
import { Route as ParentDancersIdRouteImport } from './routes/parent.dancers.$id'
import { Route as ParentBillingTicketsRouteImport } from './routes/parent.billing.tickets'
import { Route as ParentBillingPaymentMethodsRouteImport } from './routes/parent.billing.payment-methods'
import { Route as ParentBillingCheckoutReturnRouteImport } from './routes/parent.billing.checkout-return'
import { Route as ParentBillingAutoPayRouteImport } from './routes/parent.billing.auto-pay'
import { Route as AdminProgramsNewRouteImport } from './routes/admin.programs.new'
import { Route as AdminProgramsIdRouteImport } from './routes/admin.programs.$id'
import { Route as AdminProductionsNewRouteImport } from './routes/admin.productions.new'
import { Route as AdminProductionsIdRouteImport } from './routes/admin.productions.$id'
import { Route as AdminMessagesThreadIdRouteImport } from './routes/admin.messages.$threadId'
import { Route as AdminLeadsIdRouteImport } from './routes/admin.leads.$id'
import { Route as AdminFamiliesNewRouteImport } from './routes/admin.families.new'
import { Route as AdminFamiliesImportRouteImport } from './routes/admin.families.import'
import { Route as AdminFamiliesIdRouteImport } from './routes/admin.families.$id'
import { Route as AdminDancersImportRouteImport } from './routes/admin.dancers.import'
import { Route as AdminCompetitionsNewRouteImport } from './routes/admin.competitions.new'
import { Route as AdminCompetitionsIdRouteImport } from './routes/admin.competitions.$id'
import { Route as AdminClassesNewRouteImport } from './routes/admin.classes.new'
import { Route as AdminClassesIdRouteImport } from './routes/admin.classes.$id'
import { Route as AdminBillingSubscriptionsRouteImport } from './routes/admin.billing.subscriptions'
import { Route as AdminBillingPlansRouteImport } from './routes/admin.billing.plans'
import { Route as AdminBillingNewRouteImport } from './routes/admin.billing.new'
import { Route as AdminBillingLateFeesRouteImport } from './routes/admin.billing.late-fees'
import { Route as AdminBillingExportRouteImport } from './routes/admin.billing.export'
import { Route as AdminBillingFamilyIdRouteImport } from './routes/admin.billing.$familyId'
import { Route as ParentShowsShowIdSeatsRouteImport } from './routes/parent.shows.$showId.seats'
import { Route as ParentDancersIdVideosRouteImport } from './routes/parent.dancers.$id.videos'
import { Route as FacultyClassesIdAttendanceRouteImport } from './routes/faculty.classes.$id.attendance'
import { Route as AdminProductionsIdSeatMapRouteImport } from './routes/admin.productions.$id.seat-map'
import { Route as AdminProductionsIdImportLineupRouteImport } from './routes/admin.productions.$id.import-lineup'
import { Route as AdminProductionsIdConflictsRouteImport } from './routes/admin.productions.$id.conflicts'
import { Route as AdminProductionsIdByFamilyRouteImport } from './routes/admin.productions.$id.by-family'
import { Route as AdminProductionsIdByDancerRouteImport } from './routes/admin.productions.$id.by-dancer'
import { Route as AdminDancesDanceIdMediaRouteImport } from './routes/admin.dances.$danceId.media'
import { Route as AdminProductionsIdShowsShowIdRouteImport } from './routes/admin.productions.$id.shows.$showId'
import { Route as AdminCompetitionsIdRoutinesRoutineIdMediaRouteImport } from './routes/admin.competitions.$id.routines.$routineId.media'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentRoute = ParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FacultyRoute = FacultyRouteImport.update({
  id: '/faculty',
  path: '/faculty',
  getParentRoute: () => rootRouteImport,
} as any)
const DancerRoute = DancerRouteImport.update({
  id: '/dancer',
  path: '/dancer',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentIndexRoute = ParentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentRoute,
} as any)
const FacultyIndexRoute = FacultyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FacultyRoute,
} as any)
const DancerIndexRoute = DancerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DancerRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const ParentScheduleRoute = ParentScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => ParentRoute,
} as any)
const ParentProgressRoute = ParentProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => ParentRoute,
} as any)
const ParentProductionsRoute = ParentProductionsRouteImport.update({
  id: '/productions',
  path: '/productions',
  getParentRoute: () => ParentRoute,
} as any)
const ParentPassesRoute = ParentPassesRouteImport.update({
  id: '/passes',
  path: '/passes',
  getParentRoute: () => ParentRoute,
} as any)
const ParentMessagesRoute = ParentMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => ParentRoute,
} as any)
const ParentDancersRoute = ParentDancersRouteImport.update({
  id: '/dancers',
  path: '/dancers',
  getParentRoute: () => ParentRoute,
} as any)
const ParentCompetitionsRoute = ParentCompetitionsRouteImport.update({
  id: '/competitions',
  path: '/competitions',
  getParentRoute: () => ParentRoute,
} as any)
const ParentBillingRoute = ParentBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => ParentRoute,
} as any)
const FacultyProductionsRoute = FacultyProductionsRouteImport.update({
  id: '/productions',
  path: '/productions',
  getParentRoute: () => FacultyRoute,
} as any)
const FacultyClassesRoute = FacultyClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => FacultyRoute,
} as any)
const DancerVideosRoute = DancerVideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => DancerRoute,
} as any)
const DancerCompetitionsRoute = DancerCompetitionsRouteImport.update({
  id: '/competitions',
  path: '/competitions',
  getParentRoute: () => DancerRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/auth/reset',
  path: '/auth/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSecurityRoute = AdminSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRecitalPackagesRoute = AdminRecitalPackagesRouteImport.update({
  id: '/recital-packages',
  path: '/recital-packages',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProgramsRoute = AdminProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductionsRoute = AdminProductionsRouteImport.update({
  id: '/productions',
  path: '/productions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMessagesRoute = AdminMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFamiliesRoute = AdminFamiliesRouteImport.update({
  id: '/families',
  path: '/families',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDancersRoute = AdminDancersRouteImport.update({
  id: '/dancers',
  path: '/dancers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCostRoute = AdminCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompetitionsRoute = AdminCompetitionsRouteImport.update({
  id: '/competitions',
  path: '/competitions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClassesRoute = AdminClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBroadcastsRoute = AdminBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssessmentsRoute = AdminAssessmentsRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => AdminRoute,
} as any)
const ParentMessagesIndexRoute = ParentMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentMessagesRoute,
} as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminReportsRoute,
} as any)
const AdminRecitalPackagesIndexRoute =
  AdminRecitalPackagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminRecitalPackagesRoute,
  } as any)
const AdminProgramsIndexRoute = AdminProgramsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminProgramsRoute,
} as any)
const AdminProductionsIndexRoute = AdminProductionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminProductionsRoute,
} as any)
const AdminMessagesIndexRoute = AdminMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminMessagesRoute,
} as any)
const AdminLeadsIndexRoute = AdminLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLeadsRoute,
} as any)
const AdminFamiliesIndexRoute = AdminFamiliesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFamiliesRoute,
} as any)
const AdminCompetitionsIndexRoute = AdminCompetitionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminCompetitionsRoute,
} as any)
const AdminClassesIndexRoute = AdminClassesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminClassesRoute,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminAssessmentsIndexRoute = AdminAssessmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAssessmentsRoute,
} as any)
const ParentSettingsNotificationsRoute =
  ParentSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => ParentRoute,
  } as any)
const ParentMessagesThreadIdRoute = ParentMessagesThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => ParentMessagesRoute,
} as any)
const ParentDancersIdRoute = ParentDancersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ParentDancersRoute,
} as any)
const ParentBillingTicketsRoute = ParentBillingTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => ParentBillingRoute,
} as any)
const ParentBillingPaymentMethodsRoute =
  ParentBillingPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => ParentBillingRoute,
  } as any)
const ParentBillingCheckoutReturnRoute =
  ParentBillingCheckoutReturnRouteImport.update({
    id: '/checkout-return',
    path: '/checkout-return',
    getParentRoute: () => ParentBillingRoute,
  } as any)
const ParentBillingAutoPayRoute = ParentBillingAutoPayRouteImport.update({
  id: '/auto-pay',
  path: '/auto-pay',
  getParentRoute: () => ParentBillingRoute,
} as any)
const AdminProgramsNewRoute = AdminProgramsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminProgramsRoute,
} as any)
const AdminProgramsIdRoute = AdminProgramsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminProgramsRoute,
} as any)
const AdminProductionsNewRoute = AdminProductionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminProductionsRoute,
} as any)
const AdminProductionsIdRoute = AdminProductionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminProductionsRoute,
} as any)
const AdminMessagesThreadIdRoute = AdminMessagesThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AdminMessagesRoute,
} as any)
const AdminLeadsIdRoute = AdminLeadsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminLeadsRoute,
} as any)
const AdminFamiliesNewRoute = AdminFamiliesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminFamiliesRoute,
} as any)
const AdminFamiliesImportRoute = AdminFamiliesImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminFamiliesRoute,
} as any)
const AdminFamiliesIdRoute = AdminFamiliesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminFamiliesRoute,
} as any)
const AdminDancersImportRoute = AdminDancersImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminDancersRoute,
} as any)
const AdminCompetitionsNewRoute = AdminCompetitionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminCompetitionsRoute,
} as any)
const AdminCompetitionsIdRoute = AdminCompetitionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminCompetitionsRoute,
} as any)
const AdminClassesNewRoute = AdminClassesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminClassesRoute,
} as any)
const AdminClassesIdRoute = AdminClassesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminClassesRoute,
} as any)
const AdminBillingSubscriptionsRoute =
  AdminBillingSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AdminBillingRoute,
  } as any)
const AdminBillingPlansRoute = AdminBillingPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminBillingNewRoute = AdminBillingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminBillingLateFeesRoute = AdminBillingLateFeesRouteImport.update({
  id: '/late-fees',
  path: '/late-fees',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminBillingExportRoute = AdminBillingExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminBillingFamilyIdRoute = AdminBillingFamilyIdRouteImport.update({
  id: '/$familyId',
  path: '/$familyId',
  getParentRoute: () => AdminBillingRoute,
} as any)
const ParentShowsShowIdSeatsRoute = ParentShowsShowIdSeatsRouteImport.update({
  id: '/shows/$showId/seats',
  path: '/shows/$showId/seats',
  getParentRoute: () => ParentRoute,
} as any)
const ParentDancersIdVideosRoute = ParentDancersIdVideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => ParentDancersIdRoute,
} as any)
const FacultyClassesIdAttendanceRoute =
  FacultyClassesIdAttendanceRouteImport.update({
    id: '/$id/attendance',
    path: '/$id/attendance',
    getParentRoute: () => FacultyClassesRoute,
  } as any)
const AdminProductionsIdSeatMapRoute =
  AdminProductionsIdSeatMapRouteImport.update({
    id: '/seat-map',
    path: '/seat-map',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminProductionsIdImportLineupRoute =
  AdminProductionsIdImportLineupRouteImport.update({
    id: '/import-lineup',
    path: '/import-lineup',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminProductionsIdConflictsRoute =
  AdminProductionsIdConflictsRouteImport.update({
    id: '/conflicts',
    path: '/conflicts',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminProductionsIdByFamilyRoute =
  AdminProductionsIdByFamilyRouteImport.update({
    id: '/by-family',
    path: '/by-family',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminProductionsIdByDancerRoute =
  AdminProductionsIdByDancerRouteImport.update({
    id: '/by-dancer',
    path: '/by-dancer',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminDancesDanceIdMediaRoute = AdminDancesDanceIdMediaRouteImport.update({
  id: '/dances/$danceId/media',
  path: '/dances/$danceId/media',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductionsIdShowsShowIdRoute =
  AdminProductionsIdShowsShowIdRouteImport.update({
    id: '/shows/$showId',
    path: '/shows/$showId',
    getParentRoute: () => AdminProductionsIdRoute,
  } as any)
const AdminCompetitionsIdRoutinesRoutineIdMediaRoute =
  AdminCompetitionsIdRoutinesRoutineIdMediaRouteImport.update({
    id: '/routines/$routineId/media',
    path: '/routines/$routineId/media',
    getParentRoute: () => AdminCompetitionsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dancer': typeof DancerRouteWithChildren
  '/faculty': typeof FacultyRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/parent': typeof ParentRouteWithChildren
  '/signup': typeof SignupRoute
  '/admin/assessments': typeof AdminAssessmentsRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/classes': typeof AdminClassesRouteWithChildren
  '/admin/competitions': typeof AdminCompetitionsRouteWithChildren
  '/admin/cost': typeof AdminCostRoute
  '/admin/dancers': typeof AdminDancersRouteWithChildren
  '/admin/families': typeof AdminFamiliesRouteWithChildren
  '/admin/leads': typeof AdminLeadsRouteWithChildren
  '/admin/messages': typeof AdminMessagesRouteWithChildren
  '/admin/productions': typeof AdminProductionsRouteWithChildren
  '/admin/programs': typeof AdminProgramsRouteWithChildren
  '/admin/recital-packages': typeof AdminRecitalPackagesRouteWithChildren
  '/admin/reports': typeof AdminReportsRouteWithChildren
  '/admin/security': typeof AdminSecurityRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/dancer/competitions': typeof DancerCompetitionsRoute
  '/dancer/videos': typeof DancerVideosRoute
  '/faculty/classes': typeof FacultyClassesRouteWithChildren
  '/faculty/productions': typeof FacultyProductionsRoute
  '/parent/billing': typeof ParentBillingRouteWithChildren
  '/parent/competitions': typeof ParentCompetitionsRoute
  '/parent/dancers': typeof ParentDancersRouteWithChildren
  '/parent/messages': typeof ParentMessagesRouteWithChildren
  '/parent/passes': typeof ParentPassesRoute
  '/parent/productions': typeof ParentProductionsRoute
  '/parent/progress': typeof ParentProgressRoute
  '/parent/schedule': typeof ParentScheduleRoute
  '/admin/': typeof AdminIndexRoute
  '/dancer/': typeof DancerIndexRoute
  '/faculty/': typeof FacultyIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/admin/billing/$familyId': typeof AdminBillingFamilyIdRoute
  '/admin/billing/export': typeof AdminBillingExportRoute
  '/admin/billing/late-fees': typeof AdminBillingLateFeesRoute
  '/admin/billing/new': typeof AdminBillingNewRoute
  '/admin/billing/plans': typeof AdminBillingPlansRoute
  '/admin/billing/subscriptions': typeof AdminBillingSubscriptionsRoute
  '/admin/classes/$id': typeof AdminClassesIdRoute
  '/admin/classes/new': typeof AdminClassesNewRoute
  '/admin/competitions/$id': typeof AdminCompetitionsIdRouteWithChildren
  '/admin/competitions/new': typeof AdminCompetitionsNewRoute
  '/admin/dancers/import': typeof AdminDancersImportRoute
  '/admin/families/$id': typeof AdminFamiliesIdRoute
  '/admin/families/import': typeof AdminFamiliesImportRoute
  '/admin/families/new': typeof AdminFamiliesNewRoute
  '/admin/leads/$id': typeof AdminLeadsIdRoute
  '/admin/messages/$threadId': typeof AdminMessagesThreadIdRoute
  '/admin/productions/$id': typeof AdminProductionsIdRouteWithChildren
  '/admin/productions/new': typeof AdminProductionsNewRoute
  '/admin/programs/$id': typeof AdminProgramsIdRoute
  '/admin/programs/new': typeof AdminProgramsNewRoute
  '/parent/billing/auto-pay': typeof ParentBillingAutoPayRoute
  '/parent/billing/checkout-return': typeof ParentBillingCheckoutReturnRoute
  '/parent/billing/payment-methods': typeof ParentBillingPaymentMethodsRoute
  '/parent/billing/tickets': typeof ParentBillingTicketsRoute
  '/parent/dancers/$id': typeof ParentDancersIdRouteWithChildren
  '/parent/messages/$threadId': typeof ParentMessagesThreadIdRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/admin/assessments/': typeof AdminAssessmentsIndexRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/classes/': typeof AdminClassesIndexRoute
  '/admin/competitions/': typeof AdminCompetitionsIndexRoute
  '/admin/families/': typeof AdminFamiliesIndexRoute
  '/admin/leads/': typeof AdminLeadsIndexRoute
  '/admin/messages/': typeof AdminMessagesIndexRoute
  '/admin/productions/': typeof AdminProductionsIndexRoute
  '/admin/programs/': typeof AdminProgramsIndexRoute
  '/admin/recital-packages/': typeof AdminRecitalPackagesIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/parent/messages/': typeof ParentMessagesIndexRoute
  '/admin/dances/$danceId/media': typeof AdminDancesDanceIdMediaRoute
  '/admin/productions/$id/by-dancer': typeof AdminProductionsIdByDancerRoute
  '/admin/productions/$id/by-family': typeof AdminProductionsIdByFamilyRoute
  '/admin/productions/$id/conflicts': typeof AdminProductionsIdConflictsRoute
  '/admin/productions/$id/import-lineup': typeof AdminProductionsIdImportLineupRoute
  '/admin/productions/$id/seat-map': typeof AdminProductionsIdSeatMapRoute
  '/faculty/classes/$id/attendance': typeof FacultyClassesIdAttendanceRoute
  '/parent/dancers/$id/videos': typeof ParentDancersIdVideosRoute
  '/parent/shows/$showId/seats': typeof ParentShowsShowIdSeatsRoute
  '/admin/productions/$id/shows/$showId': typeof AdminProductionsIdShowsShowIdRoute
  '/admin/competitions/$id/routines/$routineId/media': typeof AdminCompetitionsIdRoutinesRoutineIdMediaRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/cost': typeof AdminCostRoute
  '/admin/dancers': typeof AdminDancersRouteWithChildren
  '/admin/security': typeof AdminSecurityRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/dancer/competitions': typeof DancerCompetitionsRoute
  '/dancer/videos': typeof DancerVideosRoute
  '/faculty/classes': typeof FacultyClassesRouteWithChildren
  '/faculty/productions': typeof FacultyProductionsRoute
  '/parent/billing': typeof ParentBillingRouteWithChildren
  '/parent/competitions': typeof ParentCompetitionsRoute
  '/parent/dancers': typeof ParentDancersRouteWithChildren
  '/parent/passes': typeof ParentPassesRoute
  '/parent/productions': typeof ParentProductionsRoute
  '/parent/progress': typeof ParentProgressRoute
  '/parent/schedule': typeof ParentScheduleRoute
  '/admin': typeof AdminIndexRoute
  '/dancer': typeof DancerIndexRoute
  '/faculty': typeof FacultyIndexRoute
  '/parent': typeof ParentIndexRoute
  '/admin/billing/$familyId': typeof AdminBillingFamilyIdRoute
  '/admin/billing/export': typeof AdminBillingExportRoute
  '/admin/billing/late-fees': typeof AdminBillingLateFeesRoute
  '/admin/billing/new': typeof AdminBillingNewRoute
  '/admin/billing/plans': typeof AdminBillingPlansRoute
  '/admin/billing/subscriptions': typeof AdminBillingSubscriptionsRoute
  '/admin/classes/$id': typeof AdminClassesIdRoute
  '/admin/classes/new': typeof AdminClassesNewRoute
  '/admin/competitions/$id': typeof AdminCompetitionsIdRouteWithChildren
  '/admin/competitions/new': typeof AdminCompetitionsNewRoute
  '/admin/dancers/import': typeof AdminDancersImportRoute
  '/admin/families/$id': typeof AdminFamiliesIdRoute
  '/admin/families/import': typeof AdminFamiliesImportRoute
  '/admin/families/new': typeof AdminFamiliesNewRoute
  '/admin/leads/$id': typeof AdminLeadsIdRoute
  '/admin/messages/$threadId': typeof AdminMessagesThreadIdRoute
  '/admin/productions/$id': typeof AdminProductionsIdRouteWithChildren
  '/admin/productions/new': typeof AdminProductionsNewRoute
  '/admin/programs/$id': typeof AdminProgramsIdRoute
  '/admin/programs/new': typeof AdminProgramsNewRoute
  '/parent/billing/auto-pay': typeof ParentBillingAutoPayRoute
  '/parent/billing/checkout-return': typeof ParentBillingCheckoutReturnRoute
  '/parent/billing/payment-methods': typeof ParentBillingPaymentMethodsRoute
  '/parent/billing/tickets': typeof ParentBillingTicketsRoute
  '/parent/dancers/$id': typeof ParentDancersIdRouteWithChildren
  '/parent/messages/$threadId': typeof ParentMessagesThreadIdRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/admin/assessments': typeof AdminAssessmentsIndexRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/classes': typeof AdminClassesIndexRoute
  '/admin/competitions': typeof AdminCompetitionsIndexRoute
  '/admin/families': typeof AdminFamiliesIndexRoute
  '/admin/leads': typeof AdminLeadsIndexRoute
  '/admin/messages': typeof AdminMessagesIndexRoute
  '/admin/productions': typeof AdminProductionsIndexRoute
  '/admin/programs': typeof AdminProgramsIndexRoute
  '/admin/recital-packages': typeof AdminRecitalPackagesIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/parent/messages': typeof ParentMessagesIndexRoute
  '/admin/dances/$danceId/media': typeof AdminDancesDanceIdMediaRoute
  '/admin/productions/$id/by-dancer': typeof AdminProductionsIdByDancerRoute
  '/admin/productions/$id/by-family': typeof AdminProductionsIdByFamilyRoute
  '/admin/productions/$id/conflicts': typeof AdminProductionsIdConflictsRoute
  '/admin/productions/$id/import-lineup': typeof AdminProductionsIdImportLineupRoute
  '/admin/productions/$id/seat-map': typeof AdminProductionsIdSeatMapRoute
  '/faculty/classes/$id/attendance': typeof FacultyClassesIdAttendanceRoute
  '/parent/dancers/$id/videos': typeof ParentDancersIdVideosRoute
  '/parent/shows/$showId/seats': typeof ParentShowsShowIdSeatsRoute
  '/admin/productions/$id/shows/$showId': typeof AdminProductionsIdShowsShowIdRoute
  '/admin/competitions/$id/routines/$routineId/media': typeof AdminCompetitionsIdRoutinesRoutineIdMediaRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dancer': typeof DancerRouteWithChildren
  '/faculty': typeof FacultyRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/parent': typeof ParentRouteWithChildren
  '/signup': typeof SignupRoute
  '/admin/assessments': typeof AdminAssessmentsRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/classes': typeof AdminClassesRouteWithChildren
  '/admin/competitions': typeof AdminCompetitionsRouteWithChildren
  '/admin/cost': typeof AdminCostRoute
  '/admin/dancers': typeof AdminDancersRouteWithChildren
  '/admin/families': typeof AdminFamiliesRouteWithChildren
  '/admin/leads': typeof AdminLeadsRouteWithChildren
  '/admin/messages': typeof AdminMessagesRouteWithChildren
  '/admin/productions': typeof AdminProductionsRouteWithChildren
  '/admin/programs': typeof AdminProgramsRouteWithChildren
  '/admin/recital-packages': typeof AdminRecitalPackagesRouteWithChildren
  '/admin/reports': typeof AdminReportsRouteWithChildren
  '/admin/security': typeof AdminSecurityRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset': typeof AuthResetRoute
  '/dancer/competitions': typeof DancerCompetitionsRoute
  '/dancer/videos': typeof DancerVideosRoute
  '/faculty/classes': typeof FacultyClassesRouteWithChildren
  '/faculty/productions': typeof FacultyProductionsRoute
  '/parent/billing': typeof ParentBillingRouteWithChildren
  '/parent/competitions': typeof ParentCompetitionsRoute
  '/parent/dancers': typeof ParentDancersRouteWithChildren
  '/parent/messages': typeof ParentMessagesRouteWithChildren
  '/parent/passes': typeof ParentPassesRoute
  '/parent/productions': typeof ParentProductionsRoute
  '/parent/progress': typeof ParentProgressRoute
  '/parent/schedule': typeof ParentScheduleRoute
  '/admin/': typeof AdminIndexRoute
  '/dancer/': typeof DancerIndexRoute
  '/faculty/': typeof FacultyIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/admin/billing/$familyId': typeof AdminBillingFamilyIdRoute
  '/admin/billing/export': typeof AdminBillingExportRoute
  '/admin/billing/late-fees': typeof AdminBillingLateFeesRoute
  '/admin/billing/new': typeof AdminBillingNewRoute
  '/admin/billing/plans': typeof AdminBillingPlansRoute
  '/admin/billing/subscriptions': typeof AdminBillingSubscriptionsRoute
  '/admin/classes/$id': typeof AdminClassesIdRoute
  '/admin/classes/new': typeof AdminClassesNewRoute
  '/admin/competitions/$id': typeof AdminCompetitionsIdRouteWithChildren
  '/admin/competitions/new': typeof AdminCompetitionsNewRoute
  '/admin/dancers/import': typeof AdminDancersImportRoute
  '/admin/families/$id': typeof AdminFamiliesIdRoute
  '/admin/families/import': typeof AdminFamiliesImportRoute
  '/admin/families/new': typeof AdminFamiliesNewRoute
  '/admin/leads/$id': typeof AdminLeadsIdRoute
  '/admin/messages/$threadId': typeof AdminMessagesThreadIdRoute
  '/admin/productions/$id': typeof AdminProductionsIdRouteWithChildren
  '/admin/productions/new': typeof AdminProductionsNewRoute
  '/admin/programs/$id': typeof AdminProgramsIdRoute
  '/admin/programs/new': typeof AdminProgramsNewRoute
  '/parent/billing/auto-pay': typeof ParentBillingAutoPayRoute
  '/parent/billing/checkout-return': typeof ParentBillingCheckoutReturnRoute
  '/parent/billing/payment-methods': typeof ParentBillingPaymentMethodsRoute
  '/parent/billing/tickets': typeof ParentBillingTicketsRoute
  '/parent/dancers/$id': typeof ParentDancersIdRouteWithChildren
  '/parent/messages/$threadId': typeof ParentMessagesThreadIdRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/admin/assessments/': typeof AdminAssessmentsIndexRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/classes/': typeof AdminClassesIndexRoute
  '/admin/competitions/': typeof AdminCompetitionsIndexRoute
  '/admin/families/': typeof AdminFamiliesIndexRoute
  '/admin/leads/': typeof AdminLeadsIndexRoute
  '/admin/messages/': typeof AdminMessagesIndexRoute
  '/admin/productions/': typeof AdminProductionsIndexRoute
  '/admin/programs/': typeof AdminProgramsIndexRoute
  '/admin/recital-packages/': typeof AdminRecitalPackagesIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/parent/messages/': typeof ParentMessagesIndexRoute
  '/admin/dances/$danceId/media': typeof AdminDancesDanceIdMediaRoute
  '/admin/productions/$id/by-dancer': typeof AdminProductionsIdByDancerRoute
  '/admin/productions/$id/by-family': typeof AdminProductionsIdByFamilyRoute
  '/admin/productions/$id/conflicts': typeof AdminProductionsIdConflictsRoute
  '/admin/productions/$id/import-lineup': typeof AdminProductionsIdImportLineupRoute
  '/admin/productions/$id/seat-map': typeof AdminProductionsIdSeatMapRoute
  '/faculty/classes/$id/attendance': typeof FacultyClassesIdAttendanceRoute
  '/parent/dancers/$id/videos': typeof ParentDancersIdVideosRoute
  '/parent/shows/$showId/seats': typeof ParentShowsShowIdSeatsRoute
  '/admin/productions/$id/shows/$showId': typeof AdminProductionsIdShowsShowIdRoute
  '/admin/competitions/$id/routines/$routineId/media': typeof AdminCompetitionsIdRoutinesRoutineIdMediaRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dancer'
    | '/faculty'
    | '/forgot-password'
    | '/login'
    | '/parent'
    | '/signup'
    | '/admin/assessments'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/classes'
    | '/admin/competitions'
    | '/admin/cost'
    | '/admin/dancers'
    | '/admin/families'
    | '/admin/leads'
    | '/admin/messages'
    | '/admin/productions'
    | '/admin/programs'
    | '/admin/recital-packages'
    | '/admin/reports'
    | '/admin/security'
    | '/auth/callback'
    | '/auth/reset'
    | '/dancer/competitions'
    | '/dancer/videos'
    | '/faculty/classes'
    | '/faculty/productions'
    | '/parent/billing'
    | '/parent/competitions'
    | '/parent/dancers'
    | '/parent/messages'
    | '/parent/passes'
    | '/parent/productions'
    | '/parent/progress'
    | '/parent/schedule'
    | '/admin/'
    | '/dancer/'
    | '/faculty/'
    | '/parent/'
    | '/admin/billing/$familyId'
    | '/admin/billing/export'
    | '/admin/billing/late-fees'
    | '/admin/billing/new'
    | '/admin/billing/plans'
    | '/admin/billing/subscriptions'
    | '/admin/classes/$id'
    | '/admin/classes/new'
    | '/admin/competitions/$id'
    | '/admin/competitions/new'
    | '/admin/dancers/import'
    | '/admin/families/$id'
    | '/admin/families/import'
    | '/admin/families/new'
    | '/admin/leads/$id'
    | '/admin/messages/$threadId'
    | '/admin/productions/$id'
    | '/admin/productions/new'
    | '/admin/programs/$id'
    | '/admin/programs/new'
    | '/parent/billing/auto-pay'
    | '/parent/billing/checkout-return'
    | '/parent/billing/payment-methods'
    | '/parent/billing/tickets'
    | '/parent/dancers/$id'
    | '/parent/messages/$threadId'
    | '/parent/settings/notifications'
    | '/admin/assessments/'
    | '/admin/billing/'
    | '/admin/classes/'
    | '/admin/competitions/'
    | '/admin/families/'
    | '/admin/leads/'
    | '/admin/messages/'
    | '/admin/productions/'
    | '/admin/programs/'
    | '/admin/recital-packages/'
    | '/admin/reports/'
    | '/parent/messages/'
    | '/admin/dances/$danceId/media'
    | '/admin/productions/$id/by-dancer'
    | '/admin/productions/$id/by-family'
    | '/admin/productions/$id/conflicts'
    | '/admin/productions/$id/import-lineup'
    | '/admin/productions/$id/seat-map'
    | '/faculty/classes/$id/attendance'
    | '/parent/dancers/$id/videos'
    | '/parent/shows/$showId/seats'
    | '/admin/productions/$id/shows/$showId'
    | '/admin/competitions/$id/routines/$routineId/media'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/admin/audit'
    | '/admin/broadcasts'
    | '/admin/cost'
    | '/admin/dancers'
    | '/admin/security'
    | '/auth/callback'
    | '/auth/reset'
    | '/dancer/competitions'
    | '/dancer/videos'
    | '/faculty/classes'
    | '/faculty/productions'
    | '/parent/billing'
    | '/parent/competitions'
    | '/parent/dancers'
    | '/parent/passes'
    | '/parent/productions'
    | '/parent/progress'
    | '/parent/schedule'
    | '/admin'
    | '/dancer'
    | '/faculty'
    | '/parent'
    | '/admin/billing/$familyId'
    | '/admin/billing/export'
    | '/admin/billing/late-fees'
    | '/admin/billing/new'
    | '/admin/billing/plans'
    | '/admin/billing/subscriptions'
    | '/admin/classes/$id'
    | '/admin/classes/new'
    | '/admin/competitions/$id'
    | '/admin/competitions/new'
    | '/admin/dancers/import'
    | '/admin/families/$id'
    | '/admin/families/import'
    | '/admin/families/new'
    | '/admin/leads/$id'
    | '/admin/messages/$threadId'
    | '/admin/productions/$id'
    | '/admin/productions/new'
    | '/admin/programs/$id'
    | '/admin/programs/new'
    | '/parent/billing/auto-pay'
    | '/parent/billing/checkout-return'
    | '/parent/billing/payment-methods'
    | '/parent/billing/tickets'
    | '/parent/dancers/$id'
    | '/parent/messages/$threadId'
    | '/parent/settings/notifications'
    | '/admin/assessments'
    | '/admin/billing'
    | '/admin/classes'
    | '/admin/competitions'
    | '/admin/families'
    | '/admin/leads'
    | '/admin/messages'
    | '/admin/productions'
    | '/admin/programs'
    | '/admin/recital-packages'
    | '/admin/reports'
    | '/parent/messages'
    | '/admin/dances/$danceId/media'
    | '/admin/productions/$id/by-dancer'
    | '/admin/productions/$id/by-family'
    | '/admin/productions/$id/conflicts'
    | '/admin/productions/$id/import-lineup'
    | '/admin/productions/$id/seat-map'
    | '/faculty/classes/$id/attendance'
    | '/parent/dancers/$id/videos'
    | '/parent/shows/$showId/seats'
    | '/admin/productions/$id/shows/$showId'
    | '/admin/competitions/$id/routines/$routineId/media'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dancer'
    | '/faculty'
    | '/forgot-password'
    | '/login'
    | '/parent'
    | '/signup'
    | '/admin/assessments'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/classes'
    | '/admin/competitions'
    | '/admin/cost'
    | '/admin/dancers'
    | '/admin/families'
    | '/admin/leads'
    | '/admin/messages'
    | '/admin/productions'
    | '/admin/programs'
    | '/admin/recital-packages'
    | '/admin/reports'
    | '/admin/security'
    | '/auth/callback'
    | '/auth/reset'
    | '/dancer/competitions'
    | '/dancer/videos'
    | '/faculty/classes'
    | '/faculty/productions'
    | '/parent/billing'
    | '/parent/competitions'
    | '/parent/dancers'
    | '/parent/messages'
    | '/parent/passes'
    | '/parent/productions'
    | '/parent/progress'
    | '/parent/schedule'
    | '/admin/'
    | '/dancer/'
    | '/faculty/'
    | '/parent/'
    | '/admin/billing/$familyId'
    | '/admin/billing/export'
    | '/admin/billing/late-fees'
    | '/admin/billing/new'
    | '/admin/billing/plans'
    | '/admin/billing/subscriptions'
    | '/admin/classes/$id'
    | '/admin/classes/new'
    | '/admin/competitions/$id'
    | '/admin/competitions/new'
    | '/admin/dancers/import'
    | '/admin/families/$id'
    | '/admin/families/import'
    | '/admin/families/new'
    | '/admin/leads/$id'
    | '/admin/messages/$threadId'
    | '/admin/productions/$id'
    | '/admin/productions/new'
    | '/admin/programs/$id'
    | '/admin/programs/new'
    | '/parent/billing/auto-pay'
    | '/parent/billing/checkout-return'
    | '/parent/billing/payment-methods'
    | '/parent/billing/tickets'
    | '/parent/dancers/$id'
    | '/parent/messages/$threadId'
    | '/parent/settings/notifications'
    | '/admin/assessments/'
    | '/admin/billing/'
    | '/admin/classes/'
    | '/admin/competitions/'
    | '/admin/families/'
    | '/admin/leads/'
    | '/admin/messages/'
    | '/admin/productions/'
    | '/admin/programs/'
    | '/admin/recital-packages/'
    | '/admin/reports/'
    | '/parent/messages/'
    | '/admin/dances/$danceId/media'
    | '/admin/productions/$id/by-dancer'
    | '/admin/productions/$id/by-family'
    | '/admin/productions/$id/conflicts'
    | '/admin/productions/$id/import-lineup'
    | '/admin/productions/$id/seat-map'
    | '/faculty/classes/$id/attendance'
    | '/parent/dancers/$id/videos'
    | '/parent/shows/$showId/seats'
    | '/admin/productions/$id/shows/$showId'
    | '/admin/competitions/$id/routines/$routineId/media'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  DancerRoute: typeof DancerRouteWithChildren
  FacultyRoute: typeof FacultyRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ParentRoute: typeof ParentRouteWithChildren
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthResetRoute: typeof AuthResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent': {
      id: '/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faculty': {
      id: '/faculty'
      path: '/faculty'
      fullPath: '/faculty'
      preLoaderRoute: typeof FacultyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dancer': {
      id: '/dancer'
      path: '/dancer'
      fullPath: '/dancer'
      preLoaderRoute: typeof DancerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/': {
      id: '/parent/'
      path: '/'
      fullPath: '/parent/'
      preLoaderRoute: typeof ParentIndexRouteImport
      parentRoute: typeof ParentRoute
    }
    '/faculty/': {
      id: '/faculty/'
      path: '/'
      fullPath: '/faculty/'
      preLoaderRoute: typeof FacultyIndexRouteImport
      parentRoute: typeof FacultyRoute
    }
    '/dancer/': {
      id: '/dancer/'
      path: '/'
      fullPath: '/dancer/'
      preLoaderRoute: typeof DancerIndexRouteImport
      parentRoute: typeof DancerRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/parent/schedule': {
      id: '/parent/schedule'
      path: '/schedule'
      fullPath: '/parent/schedule'
      preLoaderRoute: typeof ParentScheduleRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/progress': {
      id: '/parent/progress'
      path: '/progress'
      fullPath: '/parent/progress'
      preLoaderRoute: typeof ParentProgressRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/productions': {
      id: '/parent/productions'
      path: '/productions'
      fullPath: '/parent/productions'
      preLoaderRoute: typeof ParentProductionsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/passes': {
      id: '/parent/passes'
      path: '/passes'
      fullPath: '/parent/passes'
      preLoaderRoute: typeof ParentPassesRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/messages': {
      id: '/parent/messages'
      path: '/messages'
      fullPath: '/parent/messages'
      preLoaderRoute: typeof ParentMessagesRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/dancers': {
      id: '/parent/dancers'
      path: '/dancers'
      fullPath: '/parent/dancers'
      preLoaderRoute: typeof ParentDancersRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/competitions': {
      id: '/parent/competitions'
      path: '/competitions'
      fullPath: '/parent/competitions'
      preLoaderRoute: typeof ParentCompetitionsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/billing': {
      id: '/parent/billing'
      path: '/billing'
      fullPath: '/parent/billing'
      preLoaderRoute: typeof ParentBillingRouteImport
      parentRoute: typeof ParentRoute
    }
    '/faculty/productions': {
      id: '/faculty/productions'
      path: '/productions'
      fullPath: '/faculty/productions'
      preLoaderRoute: typeof FacultyProductionsRouteImport
      parentRoute: typeof FacultyRoute
    }
    '/faculty/classes': {
      id: '/faculty/classes'
      path: '/classes'
      fullPath: '/faculty/classes'
      preLoaderRoute: typeof FacultyClassesRouteImport
      parentRoute: typeof FacultyRoute
    }
    '/dancer/videos': {
      id: '/dancer/videos'
      path: '/videos'
      fullPath: '/dancer/videos'
      preLoaderRoute: typeof DancerVideosRouteImport
      parentRoute: typeof DancerRoute
    }
    '/dancer/competitions': {
      id: '/dancer/competitions'
      path: '/competitions'
      fullPath: '/dancer/competitions'
      preLoaderRoute: typeof DancerCompetitionsRouteImport
      parentRoute: typeof DancerRoute
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/security': {
      id: '/admin/security'
      path: '/security'
      fullPath: '/admin/security'
      preLoaderRoute: typeof AdminSecurityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recital-packages': {
      id: '/admin/recital-packages'
      path: '/recital-packages'
      fullPath: '/admin/recital-packages'
      preLoaderRoute: typeof AdminRecitalPackagesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/programs': {
      id: '/admin/programs'
      path: '/programs'
      fullPath: '/admin/programs'
      preLoaderRoute: typeof AdminProgramsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/productions': {
      id: '/admin/productions'
      path: '/productions'
      fullPath: '/admin/productions'
      preLoaderRoute: typeof AdminProductionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/messages': {
      id: '/admin/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AdminMessagesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/leads': {
      id: '/admin/leads'
      path: '/leads'
      fullPath: '/admin/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/families': {
      id: '/admin/families'
      path: '/families'
      fullPath: '/admin/families'
      preLoaderRoute: typeof AdminFamiliesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dancers': {
      id: '/admin/dancers'
      path: '/dancers'
      fullPath: '/admin/dancers'
      preLoaderRoute: typeof AdminDancersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cost': {
      id: '/admin/cost'
      path: '/cost'
      fullPath: '/admin/cost'
      preLoaderRoute: typeof AdminCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/competitions': {
      id: '/admin/competitions'
      path: '/competitions'
      fullPath: '/admin/competitions'
      preLoaderRoute: typeof AdminCompetitionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/classes': {
      id: '/admin/classes'
      path: '/classes'
      fullPath: '/admin/classes'
      preLoaderRoute: typeof AdminClassesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/broadcasts': {
      id: '/admin/broadcasts'
      path: '/broadcasts'
      fullPath: '/admin/broadcasts'
      preLoaderRoute: typeof AdminBroadcastsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/assessments': {
      id: '/admin/assessments'
      path: '/assessments'
      fullPath: '/admin/assessments'
      preLoaderRoute: typeof AdminAssessmentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/parent/messages/': {
      id: '/parent/messages/'
      path: '/'
      fullPath: '/parent/messages/'
      preLoaderRoute: typeof ParentMessagesIndexRouteImport
      parentRoute: typeof ParentMessagesRoute
    }
    '/admin/reports/': {
      id: '/admin/reports/'
      path: '/'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof AdminReportsRoute
    }
    '/admin/recital-packages/': {
      id: '/admin/recital-packages/'
      path: '/'
      fullPath: '/admin/recital-packages/'
      preLoaderRoute: typeof AdminRecitalPackagesIndexRouteImport
      parentRoute: typeof AdminRecitalPackagesRoute
    }
    '/admin/programs/': {
      id: '/admin/programs/'
      path: '/'
      fullPath: '/admin/programs/'
      preLoaderRoute: typeof AdminProgramsIndexRouteImport
      parentRoute: typeof AdminProgramsRoute
    }
    '/admin/productions/': {
      id: '/admin/productions/'
      path: '/'
      fullPath: '/admin/productions/'
      preLoaderRoute: typeof AdminProductionsIndexRouteImport
      parentRoute: typeof AdminProductionsRoute
    }
    '/admin/messages/': {
      id: '/admin/messages/'
      path: '/'
      fullPath: '/admin/messages/'
      preLoaderRoute: typeof AdminMessagesIndexRouteImport
      parentRoute: typeof AdminMessagesRoute
    }
    '/admin/leads/': {
      id: '/admin/leads/'
      path: '/'
      fullPath: '/admin/leads/'
      preLoaderRoute: typeof AdminLeadsIndexRouteImport
      parentRoute: typeof AdminLeadsRoute
    }
    '/admin/families/': {
      id: '/admin/families/'
      path: '/'
      fullPath: '/admin/families/'
      preLoaderRoute: typeof AdminFamiliesIndexRouteImport
      parentRoute: typeof AdminFamiliesRoute
    }
    '/admin/competitions/': {
      id: '/admin/competitions/'
      path: '/'
      fullPath: '/admin/competitions/'
      preLoaderRoute: typeof AdminCompetitionsIndexRouteImport
      parentRoute: typeof AdminCompetitionsRoute
    }
    '/admin/classes/': {
      id: '/admin/classes/'
      path: '/'
      fullPath: '/admin/classes/'
      preLoaderRoute: typeof AdminClassesIndexRouteImport
      parentRoute: typeof AdminClassesRoute
    }
    '/admin/billing/': {
      id: '/admin/billing/'
      path: '/'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/assessments/': {
      id: '/admin/assessments/'
      path: '/'
      fullPath: '/admin/assessments/'
      preLoaderRoute: typeof AdminAssessmentsIndexRouteImport
      parentRoute: typeof AdminAssessmentsRoute
    }
    '/parent/settings/notifications': {
      id: '/parent/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/parent/settings/notifications'
      preLoaderRoute: typeof ParentSettingsNotificationsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/messages/$threadId': {
      id: '/parent/messages/$threadId'
      path: '/$threadId'
      fullPath: '/parent/messages/$threadId'
      preLoaderRoute: typeof ParentMessagesThreadIdRouteImport
      parentRoute: typeof ParentMessagesRoute
    }
    '/parent/dancers/$id': {
      id: '/parent/dancers/$id'
      path: '/$id'
      fullPath: '/parent/dancers/$id'
      preLoaderRoute: typeof ParentDancersIdRouteImport
      parentRoute: typeof ParentDancersRoute
    }
    '/parent/billing/tickets': {
      id: '/parent/billing/tickets'
      path: '/tickets'
      fullPath: '/parent/billing/tickets'
      preLoaderRoute: typeof ParentBillingTicketsRouteImport
      parentRoute: typeof ParentBillingRoute
    }
    '/parent/billing/payment-methods': {
      id: '/parent/billing/payment-methods'
      path: '/payment-methods'
      fullPath: '/parent/billing/payment-methods'
      preLoaderRoute: typeof ParentBillingPaymentMethodsRouteImport
      parentRoute: typeof ParentBillingRoute
    }
    '/parent/billing/checkout-return': {
      id: '/parent/billing/checkout-return'
      path: '/checkout-return'
      fullPath: '/parent/billing/checkout-return'
      preLoaderRoute: typeof ParentBillingCheckoutReturnRouteImport
      parentRoute: typeof ParentBillingRoute
    }
    '/parent/billing/auto-pay': {
      id: '/parent/billing/auto-pay'
      path: '/auto-pay'
      fullPath: '/parent/billing/auto-pay'
      preLoaderRoute: typeof ParentBillingAutoPayRouteImport
      parentRoute: typeof ParentBillingRoute
    }
    '/admin/programs/new': {
      id: '/admin/programs/new'
      path: '/new'
      fullPath: '/admin/programs/new'
      preLoaderRoute: typeof AdminProgramsNewRouteImport
      parentRoute: typeof AdminProgramsRoute
    }
    '/admin/programs/$id': {
      id: '/admin/programs/$id'
      path: '/$id'
      fullPath: '/admin/programs/$id'
      preLoaderRoute: typeof AdminProgramsIdRouteImport
      parentRoute: typeof AdminProgramsRoute
    }
    '/admin/productions/new': {
      id: '/admin/productions/new'
      path: '/new'
      fullPath: '/admin/productions/new'
      preLoaderRoute: typeof AdminProductionsNewRouteImport
      parentRoute: typeof AdminProductionsRoute
    }
    '/admin/productions/$id': {
      id: '/admin/productions/$id'
      path: '/$id'
      fullPath: '/admin/productions/$id'
      preLoaderRoute: typeof AdminProductionsIdRouteImport
      parentRoute: typeof AdminProductionsRoute
    }
    '/admin/messages/$threadId': {
      id: '/admin/messages/$threadId'
      path: '/$threadId'
      fullPath: '/admin/messages/$threadId'
      preLoaderRoute: typeof AdminMessagesThreadIdRouteImport
      parentRoute: typeof AdminMessagesRoute
    }
    '/admin/leads/$id': {
      id: '/admin/leads/$id'
      path: '/$id'
      fullPath: '/admin/leads/$id'
      preLoaderRoute: typeof AdminLeadsIdRouteImport
      parentRoute: typeof AdminLeadsRoute
    }
    '/admin/families/new': {
      id: '/admin/families/new'
      path: '/new'
      fullPath: '/admin/families/new'
      preLoaderRoute: typeof AdminFamiliesNewRouteImport
      parentRoute: typeof AdminFamiliesRoute
    }
    '/admin/families/import': {
      id: '/admin/families/import'
      path: '/import'
      fullPath: '/admin/families/import'
      preLoaderRoute: typeof AdminFamiliesImportRouteImport
      parentRoute: typeof AdminFamiliesRoute
    }
    '/admin/families/$id': {
      id: '/admin/families/$id'
      path: '/$id'
      fullPath: '/admin/families/$id'
      preLoaderRoute: typeof AdminFamiliesIdRouteImport
      parentRoute: typeof AdminFamiliesRoute
    }
    '/admin/dancers/import': {
      id: '/admin/dancers/import'
      path: '/import'
      fullPath: '/admin/dancers/import'
      preLoaderRoute: typeof AdminDancersImportRouteImport
      parentRoute: typeof AdminDancersRoute
    }
    '/admin/competitions/new': {
      id: '/admin/competitions/new'
      path: '/new'
      fullPath: '/admin/competitions/new'
      preLoaderRoute: typeof AdminCompetitionsNewRouteImport
      parentRoute: typeof AdminCompetitionsRoute
    }
    '/admin/competitions/$id': {
      id: '/admin/competitions/$id'
      path: '/$id'
      fullPath: '/admin/competitions/$id'
      preLoaderRoute: typeof AdminCompetitionsIdRouteImport
      parentRoute: typeof AdminCompetitionsRoute
    }
    '/admin/classes/new': {
      id: '/admin/classes/new'
      path: '/new'
      fullPath: '/admin/classes/new'
      preLoaderRoute: typeof AdminClassesNewRouteImport
      parentRoute: typeof AdminClassesRoute
    }
    '/admin/classes/$id': {
      id: '/admin/classes/$id'
      path: '/$id'
      fullPath: '/admin/classes/$id'
      preLoaderRoute: typeof AdminClassesIdRouteImport
      parentRoute: typeof AdminClassesRoute
    }
    '/admin/billing/subscriptions': {
      id: '/admin/billing/subscriptions'
      path: '/subscriptions'
      fullPath: '/admin/billing/subscriptions'
      preLoaderRoute: typeof AdminBillingSubscriptionsRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/billing/plans': {
      id: '/admin/billing/plans'
      path: '/plans'
      fullPath: '/admin/billing/plans'
      preLoaderRoute: typeof AdminBillingPlansRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/billing/new': {
      id: '/admin/billing/new'
      path: '/new'
      fullPath: '/admin/billing/new'
      preLoaderRoute: typeof AdminBillingNewRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/billing/late-fees': {
      id: '/admin/billing/late-fees'
      path: '/late-fees'
      fullPath: '/admin/billing/late-fees'
      preLoaderRoute: typeof AdminBillingLateFeesRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/billing/export': {
      id: '/admin/billing/export'
      path: '/export'
      fullPath: '/admin/billing/export'
      preLoaderRoute: typeof AdminBillingExportRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/billing/$familyId': {
      id: '/admin/billing/$familyId'
      path: '/$familyId'
      fullPath: '/admin/billing/$familyId'
      preLoaderRoute: typeof AdminBillingFamilyIdRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/parent/shows/$showId/seats': {
      id: '/parent/shows/$showId/seats'
      path: '/shows/$showId/seats'
      fullPath: '/parent/shows/$showId/seats'
      preLoaderRoute: typeof ParentShowsShowIdSeatsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/dancers/$id/videos': {
      id: '/parent/dancers/$id/videos'
      path: '/videos'
      fullPath: '/parent/dancers/$id/videos'
      preLoaderRoute: typeof ParentDancersIdVideosRouteImport
      parentRoute: typeof ParentDancersIdRoute
    }
    '/faculty/classes/$id/attendance': {
      id: '/faculty/classes/$id/attendance'
      path: '/$id/attendance'
      fullPath: '/faculty/classes/$id/attendance'
      preLoaderRoute: typeof FacultyClassesIdAttendanceRouteImport
      parentRoute: typeof FacultyClassesRoute
    }
    '/admin/productions/$id/seat-map': {
      id: '/admin/productions/$id/seat-map'
      path: '/seat-map'
      fullPath: '/admin/productions/$id/seat-map'
      preLoaderRoute: typeof AdminProductionsIdSeatMapRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/productions/$id/import-lineup': {
      id: '/admin/productions/$id/import-lineup'
      path: '/import-lineup'
      fullPath: '/admin/productions/$id/import-lineup'
      preLoaderRoute: typeof AdminProductionsIdImportLineupRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/productions/$id/conflicts': {
      id: '/admin/productions/$id/conflicts'
      path: '/conflicts'
      fullPath: '/admin/productions/$id/conflicts'
      preLoaderRoute: typeof AdminProductionsIdConflictsRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/productions/$id/by-family': {
      id: '/admin/productions/$id/by-family'
      path: '/by-family'
      fullPath: '/admin/productions/$id/by-family'
      preLoaderRoute: typeof AdminProductionsIdByFamilyRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/productions/$id/by-dancer': {
      id: '/admin/productions/$id/by-dancer'
      path: '/by-dancer'
      fullPath: '/admin/productions/$id/by-dancer'
      preLoaderRoute: typeof AdminProductionsIdByDancerRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/dances/$danceId/media': {
      id: '/admin/dances/$danceId/media'
      path: '/dances/$danceId/media'
      fullPath: '/admin/dances/$danceId/media'
      preLoaderRoute: typeof AdminDancesDanceIdMediaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/productions/$id/shows/$showId': {
      id: '/admin/productions/$id/shows/$showId'
      path: '/shows/$showId'
      fullPath: '/admin/productions/$id/shows/$showId'
      preLoaderRoute: typeof AdminProductionsIdShowsShowIdRouteImport
      parentRoute: typeof AdminProductionsIdRoute
    }
    '/admin/competitions/$id/routines/$routineId/media': {
      id: '/admin/competitions/$id/routines/$routineId/media'
      path: '/routines/$routineId/media'
      fullPath: '/admin/competitions/$id/routines/$routineId/media'
      preLoaderRoute: typeof AdminCompetitionsIdRoutinesRoutineIdMediaRouteImport
      parentRoute: typeof AdminCompetitionsIdRoute
    }
  }
}

interface AdminAssessmentsRouteChildren {
  AdminAssessmentsIndexRoute: typeof AdminAssessmentsIndexRoute
}

const AdminAssessmentsRouteChildren: AdminAssessmentsRouteChildren = {
  AdminAssessmentsIndexRoute: AdminAssessmentsIndexRoute,
}

const AdminAssessmentsRouteWithChildren =
  AdminAssessmentsRoute._addFileChildren(AdminAssessmentsRouteChildren)

interface AdminBillingRouteChildren {
  AdminBillingFamilyIdRoute: typeof AdminBillingFamilyIdRoute
  AdminBillingExportRoute: typeof AdminBillingExportRoute
  AdminBillingLateFeesRoute: typeof AdminBillingLateFeesRoute
  AdminBillingNewRoute: typeof AdminBillingNewRoute
  AdminBillingPlansRoute: typeof AdminBillingPlansRoute
  AdminBillingSubscriptionsRoute: typeof AdminBillingSubscriptionsRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
}

const AdminBillingRouteChildren: AdminBillingRouteChildren = {
  AdminBillingFamilyIdRoute: AdminBillingFamilyIdRoute,
  AdminBillingExportRoute: AdminBillingExportRoute,
  AdminBillingLateFeesRoute: AdminBillingLateFeesRoute,
  AdminBillingNewRoute: AdminBillingNewRoute,
  AdminBillingPlansRoute: AdminBillingPlansRoute,
  AdminBillingSubscriptionsRoute: AdminBillingSubscriptionsRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
}

const AdminBillingRouteWithChildren = AdminBillingRoute._addFileChildren(
  AdminBillingRouteChildren,
)

interface AdminClassesRouteChildren {
  AdminClassesIdRoute: typeof AdminClassesIdRoute
  AdminClassesNewRoute: typeof AdminClassesNewRoute
  AdminClassesIndexRoute: typeof AdminClassesIndexRoute
}

const AdminClassesRouteChildren: AdminClassesRouteChildren = {
  AdminClassesIdRoute: AdminClassesIdRoute,
  AdminClassesNewRoute: AdminClassesNewRoute,
  AdminClassesIndexRoute: AdminClassesIndexRoute,
}

const AdminClassesRouteWithChildren = AdminClassesRoute._addFileChildren(
  AdminClassesRouteChildren,
)

interface AdminCompetitionsIdRouteChildren {
  AdminCompetitionsIdRoutinesRoutineIdMediaRoute: typeof AdminCompetitionsIdRoutinesRoutineIdMediaRoute
}

const AdminCompetitionsIdRouteChildren: AdminCompetitionsIdRouteChildren = {
  AdminCompetitionsIdRoutinesRoutineIdMediaRoute:
    AdminCompetitionsIdRoutinesRoutineIdMediaRoute,
}

const AdminCompetitionsIdRouteWithChildren =
  AdminCompetitionsIdRoute._addFileChildren(AdminCompetitionsIdRouteChildren)

interface AdminCompetitionsRouteChildren {
  AdminCompetitionsIdRoute: typeof AdminCompetitionsIdRouteWithChildren
  AdminCompetitionsNewRoute: typeof AdminCompetitionsNewRoute
  AdminCompetitionsIndexRoute: typeof AdminCompetitionsIndexRoute
}

const AdminCompetitionsRouteChildren: AdminCompetitionsRouteChildren = {
  AdminCompetitionsIdRoute: AdminCompetitionsIdRouteWithChildren,
  AdminCompetitionsNewRoute: AdminCompetitionsNewRoute,
  AdminCompetitionsIndexRoute: AdminCompetitionsIndexRoute,
}

const AdminCompetitionsRouteWithChildren =
  AdminCompetitionsRoute._addFileChildren(AdminCompetitionsRouteChildren)

interface AdminDancersRouteChildren {
  AdminDancersImportRoute: typeof AdminDancersImportRoute
}

const AdminDancersRouteChildren: AdminDancersRouteChildren = {
  AdminDancersImportRoute: AdminDancersImportRoute,
}

const AdminDancersRouteWithChildren = AdminDancersRoute._addFileChildren(
  AdminDancersRouteChildren,
)

interface AdminFamiliesRouteChildren {
  AdminFamiliesIdRoute: typeof AdminFamiliesIdRoute
  AdminFamiliesImportRoute: typeof AdminFamiliesImportRoute
  AdminFamiliesNewRoute: typeof AdminFamiliesNewRoute
  AdminFamiliesIndexRoute: typeof AdminFamiliesIndexRoute
}

const AdminFamiliesRouteChildren: AdminFamiliesRouteChildren = {
  AdminFamiliesIdRoute: AdminFamiliesIdRoute,
  AdminFamiliesImportRoute: AdminFamiliesImportRoute,
  AdminFamiliesNewRoute: AdminFamiliesNewRoute,
  AdminFamiliesIndexRoute: AdminFamiliesIndexRoute,
}

const AdminFamiliesRouteWithChildren = AdminFamiliesRoute._addFileChildren(
  AdminFamiliesRouteChildren,
)

interface AdminLeadsRouteChildren {
  AdminLeadsIdRoute: typeof AdminLeadsIdRoute
  AdminLeadsIndexRoute: typeof AdminLeadsIndexRoute
}

const AdminLeadsRouteChildren: AdminLeadsRouteChildren = {
  AdminLeadsIdRoute: AdminLeadsIdRoute,
  AdminLeadsIndexRoute: AdminLeadsIndexRoute,
}

const AdminLeadsRouteWithChildren = AdminLeadsRoute._addFileChildren(
  AdminLeadsRouteChildren,
)

interface AdminMessagesRouteChildren {
  AdminMessagesThreadIdRoute: typeof AdminMessagesThreadIdRoute
  AdminMessagesIndexRoute: typeof AdminMessagesIndexRoute
}

const AdminMessagesRouteChildren: AdminMessagesRouteChildren = {
  AdminMessagesThreadIdRoute: AdminMessagesThreadIdRoute,
  AdminMessagesIndexRoute: AdminMessagesIndexRoute,
}

const AdminMessagesRouteWithChildren = AdminMessagesRoute._addFileChildren(
  AdminMessagesRouteChildren,
)

interface AdminProductionsIdRouteChildren {
  AdminProductionsIdByDancerRoute: typeof AdminProductionsIdByDancerRoute
  AdminProductionsIdByFamilyRoute: typeof AdminProductionsIdByFamilyRoute
  AdminProductionsIdConflictsRoute: typeof AdminProductionsIdConflictsRoute
  AdminProductionsIdImportLineupRoute: typeof AdminProductionsIdImportLineupRoute
  AdminProductionsIdSeatMapRoute: typeof AdminProductionsIdSeatMapRoute
  AdminProductionsIdShowsShowIdRoute: typeof AdminProductionsIdShowsShowIdRoute
}

const AdminProductionsIdRouteChildren: AdminProductionsIdRouteChildren = {
  AdminProductionsIdByDancerRoute: AdminProductionsIdByDancerRoute,
  AdminProductionsIdByFamilyRoute: AdminProductionsIdByFamilyRoute,
  AdminProductionsIdConflictsRoute: AdminProductionsIdConflictsRoute,
  AdminProductionsIdImportLineupRoute: AdminProductionsIdImportLineupRoute,
  AdminProductionsIdSeatMapRoute: AdminProductionsIdSeatMapRoute,
  AdminProductionsIdShowsShowIdRoute: AdminProductionsIdShowsShowIdRoute,
}

const AdminProductionsIdRouteWithChildren =
  AdminProductionsIdRoute._addFileChildren(AdminProductionsIdRouteChildren)

interface AdminProductionsRouteChildren {
  AdminProductionsIdRoute: typeof AdminProductionsIdRouteWithChildren
  AdminProductionsNewRoute: typeof AdminProductionsNewRoute
  AdminProductionsIndexRoute: typeof AdminProductionsIndexRoute
}

const AdminProductionsRouteChildren: AdminProductionsRouteChildren = {
  AdminProductionsIdRoute: AdminProductionsIdRouteWithChildren,
  AdminProductionsNewRoute: AdminProductionsNewRoute,
  AdminProductionsIndexRoute: AdminProductionsIndexRoute,
}

const AdminProductionsRouteWithChildren =
  AdminProductionsRoute._addFileChildren(AdminProductionsRouteChildren)

interface AdminProgramsRouteChildren {
  AdminProgramsIdRoute: typeof AdminProgramsIdRoute
  AdminProgramsNewRoute: typeof AdminProgramsNewRoute
  AdminProgramsIndexRoute: typeof AdminProgramsIndexRoute
}

const AdminProgramsRouteChildren: AdminProgramsRouteChildren = {
  AdminProgramsIdRoute: AdminProgramsIdRoute,
  AdminProgramsNewRoute: AdminProgramsNewRoute,
  AdminProgramsIndexRoute: AdminProgramsIndexRoute,
}

const AdminProgramsRouteWithChildren = AdminProgramsRoute._addFileChildren(
  AdminProgramsRouteChildren,
)

interface AdminRecitalPackagesRouteChildren {
  AdminRecitalPackagesIndexRoute: typeof AdminRecitalPackagesIndexRoute
}

const AdminRecitalPackagesRouteChildren: AdminRecitalPackagesRouteChildren = {
  AdminRecitalPackagesIndexRoute: AdminRecitalPackagesIndexRoute,
}

const AdminRecitalPackagesRouteWithChildren =
  AdminRecitalPackagesRoute._addFileChildren(AdminRecitalPackagesRouteChildren)

interface AdminReportsRouteChildren {
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
}

const AdminReportsRouteChildren: AdminReportsRouteChildren = {
  AdminReportsIndexRoute: AdminReportsIndexRoute,
}

const AdminReportsRouteWithChildren = AdminReportsRoute._addFileChildren(
  AdminReportsRouteChildren,
)

interface AdminRouteChildren {
  AdminAssessmentsRoute: typeof AdminAssessmentsRouteWithChildren
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBillingRoute: typeof AdminBillingRouteWithChildren
  AdminBroadcastsRoute: typeof AdminBroadcastsRoute
  AdminClassesRoute: typeof AdminClassesRouteWithChildren
  AdminCompetitionsRoute: typeof AdminCompetitionsRouteWithChildren
  AdminCostRoute: typeof AdminCostRoute
  AdminDancersRoute: typeof AdminDancersRouteWithChildren
  AdminFamiliesRoute: typeof AdminFamiliesRouteWithChildren
  AdminLeadsRoute: typeof AdminLeadsRouteWithChildren
  AdminMessagesRoute: typeof AdminMessagesRouteWithChildren
  AdminProductionsRoute: typeof AdminProductionsRouteWithChildren
  AdminProgramsRoute: typeof AdminProgramsRouteWithChildren
  AdminRecitalPackagesRoute: typeof AdminRecitalPackagesRouteWithChildren
  AdminReportsRoute: typeof AdminReportsRouteWithChildren
  AdminSecurityRoute: typeof AdminSecurityRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminDancesDanceIdMediaRoute: typeof AdminDancesDanceIdMediaRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAssessmentsRoute: AdminAssessmentsRouteWithChildren,
  AdminAuditRoute: AdminAuditRoute,
  AdminBillingRoute: AdminBillingRouteWithChildren,
  AdminBroadcastsRoute: AdminBroadcastsRoute,
  AdminClassesRoute: AdminClassesRouteWithChildren,
  AdminCompetitionsRoute: AdminCompetitionsRouteWithChildren,
  AdminCostRoute: AdminCostRoute,
  AdminDancersRoute: AdminDancersRouteWithChildren,
  AdminFamiliesRoute: AdminFamiliesRouteWithChildren,
  AdminLeadsRoute: AdminLeadsRouteWithChildren,
  AdminMessagesRoute: AdminMessagesRouteWithChildren,
  AdminProductionsRoute: AdminProductionsRouteWithChildren,
  AdminProgramsRoute: AdminProgramsRouteWithChildren,
  AdminRecitalPackagesRoute: AdminRecitalPackagesRouteWithChildren,
  AdminReportsRoute: AdminReportsRouteWithChildren,
  AdminSecurityRoute: AdminSecurityRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminDancesDanceIdMediaRoute: AdminDancesDanceIdMediaRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DancerRouteChildren {
  DancerCompetitionsRoute: typeof DancerCompetitionsRoute
  DancerVideosRoute: typeof DancerVideosRoute
  DancerIndexRoute: typeof DancerIndexRoute
}

const DancerRouteChildren: DancerRouteChildren = {
  DancerCompetitionsRoute: DancerCompetitionsRoute,
  DancerVideosRoute: DancerVideosRoute,
  DancerIndexRoute: DancerIndexRoute,
}

const DancerRouteWithChildren =
  DancerRoute._addFileChildren(DancerRouteChildren)

interface FacultyClassesRouteChildren {
  FacultyClassesIdAttendanceRoute: typeof FacultyClassesIdAttendanceRoute
}

const FacultyClassesRouteChildren: FacultyClassesRouteChildren = {
  FacultyClassesIdAttendanceRoute: FacultyClassesIdAttendanceRoute,
}

const FacultyClassesRouteWithChildren = FacultyClassesRoute._addFileChildren(
  FacultyClassesRouteChildren,
)

interface FacultyRouteChildren {
  FacultyClassesRoute: typeof FacultyClassesRouteWithChildren
  FacultyProductionsRoute: typeof FacultyProductionsRoute
  FacultyIndexRoute: typeof FacultyIndexRoute
}

const FacultyRouteChildren: FacultyRouteChildren = {
  FacultyClassesRoute: FacultyClassesRouteWithChildren,
  FacultyProductionsRoute: FacultyProductionsRoute,
  FacultyIndexRoute: FacultyIndexRoute,
}

const FacultyRouteWithChildren =
  FacultyRoute._addFileChildren(FacultyRouteChildren)

interface ParentBillingRouteChildren {
  ParentBillingAutoPayRoute: typeof ParentBillingAutoPayRoute
  ParentBillingCheckoutReturnRoute: typeof ParentBillingCheckoutReturnRoute
  ParentBillingPaymentMethodsRoute: typeof ParentBillingPaymentMethodsRoute
  ParentBillingTicketsRoute: typeof ParentBillingTicketsRoute
}

const ParentBillingRouteChildren: ParentBillingRouteChildren = {
  ParentBillingAutoPayRoute: ParentBillingAutoPayRoute,
  ParentBillingCheckoutReturnRoute: ParentBillingCheckoutReturnRoute,
  ParentBillingPaymentMethodsRoute: ParentBillingPaymentMethodsRoute,
  ParentBillingTicketsRoute: ParentBillingTicketsRoute,
}

const ParentBillingRouteWithChildren = ParentBillingRoute._addFileChildren(
  ParentBillingRouteChildren,
)

interface ParentDancersIdRouteChildren {
  ParentDancersIdVideosRoute: typeof ParentDancersIdVideosRoute
}

const ParentDancersIdRouteChildren: ParentDancersIdRouteChildren = {
  ParentDancersIdVideosRoute: ParentDancersIdVideosRoute,
}

const ParentDancersIdRouteWithChildren = ParentDancersIdRoute._addFileChildren(
  ParentDancersIdRouteChildren,
)

interface ParentDancersRouteChildren {
  ParentDancersIdRoute: typeof ParentDancersIdRouteWithChildren
}

const ParentDancersRouteChildren: ParentDancersRouteChildren = {
  ParentDancersIdRoute: ParentDancersIdRouteWithChildren,
}

const ParentDancersRouteWithChildren = ParentDancersRoute._addFileChildren(
  ParentDancersRouteChildren,
)

interface ParentMessagesRouteChildren {
  ParentMessagesThreadIdRoute: typeof ParentMessagesThreadIdRoute
  ParentMessagesIndexRoute: typeof ParentMessagesIndexRoute
}

const ParentMessagesRouteChildren: ParentMessagesRouteChildren = {
  ParentMessagesThreadIdRoute: ParentMessagesThreadIdRoute,
  ParentMessagesIndexRoute: ParentMessagesIndexRoute,
}

const ParentMessagesRouteWithChildren = ParentMessagesRoute._addFileChildren(
  ParentMessagesRouteChildren,
)

interface ParentRouteChildren {
  ParentBillingRoute: typeof ParentBillingRouteWithChildren
  ParentCompetitionsRoute: typeof ParentCompetitionsRoute
  ParentDancersRoute: typeof ParentDancersRouteWithChildren
  ParentMessagesRoute: typeof ParentMessagesRouteWithChildren
  ParentPassesRoute: typeof ParentPassesRoute
  ParentProductionsRoute: typeof ParentProductionsRoute
  ParentProgressRoute: typeof ParentProgressRoute
  ParentScheduleRoute: typeof ParentScheduleRoute
  ParentIndexRoute: typeof ParentIndexRoute
  ParentSettingsNotificationsRoute: typeof ParentSettingsNotificationsRoute
  ParentShowsShowIdSeatsRoute: typeof ParentShowsShowIdSeatsRoute
}

const ParentRouteChildren: ParentRouteChildren = {
  ParentBillingRoute: ParentBillingRouteWithChildren,
  ParentCompetitionsRoute: ParentCompetitionsRoute,
  ParentDancersRoute: ParentDancersRouteWithChildren,
  ParentMessagesRoute: ParentMessagesRouteWithChildren,
  ParentPassesRoute: ParentPassesRoute,
  ParentProductionsRoute: ParentProductionsRoute,
  ParentProgressRoute: ParentProgressRoute,
  ParentScheduleRoute: ParentScheduleRoute,
  ParentIndexRoute: ParentIndexRoute,
  ParentSettingsNotificationsRoute: ParentSettingsNotificationsRoute,
  ParentShowsShowIdSeatsRoute: ParentShowsShowIdSeatsRoute,
}

const ParentRouteWithChildren =
  ParentRoute._addFileChildren(ParentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  DancerRoute: DancerRouteWithChildren,
  FacultyRoute: FacultyRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ParentRoute: ParentRouteWithChildren,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthResetRoute: AuthResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
